import React, { Component } from 'react';
import { connect } from 'react-redux';
import Snackbar from 'material-ui/Snackbar';

const loginSnack = ({logged}) => <Snackbar
    open={logged}
    message="Login Successful"
    autoHideDuration={4000}
/>;

const loginSnackProps = ({auth: {logged}}) => ({logged});

export const LoginSnack = connect(loginSnackProps,null)(loginSnack);

const quoteSnack = ({quoteRequestSent, reset}) => <Snackbar
    open={quoteRequestSent}
    message="Quote Request Sent"
    autoHideDuration={4000}
    onRequestClose={_ => reset()}
/>;

const quoteSnackStateToProps = ({services: {quoteRequestSent}}) => ({quoteRequestSent});
const quoteSnackDispatchToProps = dispatch => ({reset: () => dispatch({type: "RESET_QUOTE_SNACK"})});

export const QuoteSnack = connect(quoteSnackStateToProps, quoteSnackDispatchToProps)(quoteSnack);


// WEBPACK FOOTER //
// ./src/components/Snacks.js